export const CREATE_CHECKLIST = "CREATE_CHECKLIST";
export const FETCH_CHECKLISTS = "FETCH_CHECKLISTS";
export const FETCH_CHECKLIST = "FETCH_CHECKLIST";
export const EDIT_CHECKLIST = "EDIT_CHECKLIST";
export const DELETE_CHECKLIST = "DELETE_CHECKLIST";
